import { render, staticRenderFns } from "./LabeledWrapper.vue?vue&type=template&id=7dbe139e&scoped=true&"
import script from "./LabeledWrapper.vue?vue&type=script&lang=js&"
export * from "./LabeledWrapper.vue?vue&type=script&lang=js&"
import style0 from "./LabeledWrapper.vue?vue&type=style&index=0&id=7dbe139e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbe139e",
  null
  
)

export default component.exports